/**
 * Gets a canonical base URL that will be reachable from email links
 * This prevents issues where localhost URLs are sent in emails
 */
export const getCanonicalBaseUrl = (): string => {
  // In production or when deployed, use the current origin
  if (typeof window !== 'undefined') {
    const { hostname, protocol, port } = window.location;
    
    // If we're on localhost, use a canonical URL that will be reachable
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Use the Lovable preview URL pattern if available
      // Otherwise fallback to the current URL but this might not work for emails
      const currentUrl = window.location.href;
      
      // Check if we're on a Lovable preview URL
      if (currentUrl.includes('lovable.app')) {
        // Extract the base URL from the current location
        return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
      }
      
      // For true localhost development, we need to use a reachable URL
      // This should be updated to match your actual deployed domain
      return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    }
    
    // For production domains, use the current origin
    return `${protocol}//${hostname}${port && port !== '80' && port !== '443' ? `:${port}` : ''}`;
  }
  
  // Fallback for server-side rendering
  return 'https://your-deployed-domain.com';
};

/**
 * Gets the auth redirect URL for email confirmations and password resets
 */
export const getAuthRedirectUrl = (path: string = ''): string => {
  const baseUrl = getCanonicalBaseUrl();
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
};
